import { Controller } from 'stimulus'

export default class DesignController extends Controller {
  static targets = [
    'titleLine',
    'typographyWord',
    'typographyWeightSlider',
    'typographyWeightInput',
    'typographySlantSlider',
    'typographySlantInput',
    'typographyControls',
  ]

  connect() {
    requestAnimationFrame(() => {
      this.titleLineTarget.classList.add('is-animated')
    })

    this.updateWeight({ target: this.typographyWeightSliderTarget })
    this.updateSlant({ target: this.typographySlantSliderTarget })
  }

  updateWeight(event) {
    if (event.target === this.typographyWeightInputTarget) {
      this.typographyWordTarget.style.transition = 'font-variation-settings 0.3s ease'
    } else {
      this.typographyWordTarget.style.transition = 'none'
    }

    const slider = this.typographyWeightSliderTarget
    const input = this.typographyWeightInputTarget
    const step = parseFloat(slider.step)
    const min = parseFloat(slider.min)
    const max = parseFloat(slider.max)

    let value = parseFloat(event.target.value)
    value = Math.max(min, Math.min(value, max)) // clamp
    value = Math.round((value - min) / step) * step + min // round to step

    slider.value = value
    input.value = value
    this.typographyWordTarget.style.fontVariationSettings = `'wght' ${value}, 'slnt' ${this.typographySlantSliderTarget.value}`

    const percent = ((value - min) / (max - min)) * 100
    slider.style.setProperty('--percent', `${percent}%`)
  }

  updateSlant(event) {
    if (event.target === this.typographySlantInputTarget) {
      this.typographyWordTarget.style.transition = 'font-variation-settings 0.3s ease'
    } else {
      this.typographyWordTarget.style.transition = 'none'
    }

    // 2. Sync + clamp + percent logic
    const slider = this.typographySlantSliderTarget
    const input = this.typographySlantInputTarget
    const step = parseFloat(slider.step)
    const min = parseFloat(slider.min)
    const max = parseFloat(slider.max)

    let value = parseFloat(event.target.value)
    value = Math.max(min, Math.min(value, max))
    value = Math.round((value - min) / step) * step + min

    slider.value = value
    input.value = value
    this.typographyWordTarget.style.fontVariationSettings = `'wght' ${this.typographyWeightSliderTarget.value}, 'slnt' ${value}`

    const percent = ((value - min) / (max - min)) * 100
    slider.style.setProperty('--percent', `${percent}%`)
  }
}
